import React from "react";
import errorSvg from "shared/assets/illustrations/03Page403.svg";
import "./unauthorizedPage.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


interface ISystemErrorProps {
    link:string
}
const UnauthorizedPage: React.FC<ISystemErrorProps> = (props): JSX.Element => {
    const {link} = props;
    const {t} = useTranslation(['app']);
    return (
        <div id="systemErrorComponent" className="mainContainer">
            <img alt="illustration" src={errorSvg} />
            <div>
                <div className="title">
                    {t('errorPage.Unauthorized')}
                </div>

                <div className="subtitle"></div>
                <p className="text">{t('errorPage.UnauthorizedText')}</p>
            </div>
        </div>
    )
}

export default UnauthorizedPage;